import { gql } from 'apollo-angular';
import { CategoryParams } from '../categories-graphql.service';

const GET_PRODUCT_ATTRIBUTES_IN_CATEGORY_BY_SEARCH = (
  categoryParams: CategoryParams,
  categoryAttributeTypes: string[],
) => {
  return gql`
    query getProductAttributesInCategoryBySearch{
      optimizedPurchasedProducts (
        ${
          categoryParams.categorizationSchemeId
            ? 'categorizationSchemeId: ' + categoryParams.categorizationSchemeId
            : ''
        }
        ${
          categoryParams.categoryId
            ? 'categoryId: ' + categoryParams.categoryId
            : ''
        }
        ${
          categoryParams.searchTerm
            ? ', searchValue: "' + categoryParams.searchTerm + '"'
            : ''
        }
        categoryAttributeTypes: ${JSON.stringify(categoryAttributeTypes)}
      ) {
        id,
        productAttributes {
          attributes {
            name
            value
          }
          attributeType
        }
      }
    }
  `;
};

export default GET_PRODUCT_ATTRIBUTES_IN_CATEGORY_BY_SEARCH;
